






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Cover extends Vue {
  @Prop() value!: string;
}
